import { createFileRoute } from "@tanstack/react-router";

import StoreSettingsPage from "@/admin/settings/store/page";

export const Route = createFileRoute("/app/$storeId/settings/store")({
    component: RouteComponent,
});

function RouteComponent() {
    return <StoreSettingsPage />;
}
